/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import {
  EMPTY_STRING,
  INVALID_EMAIL_ADDRESS,
  LOCAL_STORE_AUTH_TOKEN,
  PASSWORD_EMPTY,
  USERNAME_EMPTY,
} from '../../constants/constants';
import {
  PRENTROM_CREATE_ACCOUT_URL,
  PRENTROM_FORGOT_PASSWORD_URL,
  TARGET_BLANK
} from '../../constants/api';
import { PATH_DEFAULT } from '../../routes';
import { isEmailValid } from '../../common/helpers/common.helpers';
import TextInput from '../../common/components/text-input/text-input.component';
import Button from '../../common/components/button/button.component';
import {
  faCircleNotch,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './authentication.style.css';

/**
 * Class representing the authentication component.
 * @extends Component
 * */
@inject('authenticationStore')
@observer
class Authentication extends Component {

  static propTypes = {
    authenticationStore: PropTypes.shape({
      password: PropTypes.string,
      username: PropTypes.string,
    }),
    history: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
  };

  static defaultProps = {
    authenticationStore: {
      password: EMPTY_STRING,
      username: EMPTY_STRING,
    }
  };

  /**
   * Sets the username on input change.
   * @param {string} value - The value.
   * */
  onUsernameChange = (value) => {
    const { authenticationStore: { setUsername } } = this.props;

    setUsername(value);
  };

  /**
   * Sets the password on input change.
   * @param {string} value - The value.
   * */
  onPasswordChange = (value) => {
    const { authenticationStore: { setPassword } } = this.props;

    setPassword(value);
  };

  /**
   * Sets the password on enter key input change and login.
   * @param {string} value - The value.
   * */
  onEnterKeyPasswordChange = (value) => {
    const { authenticationStore: { setPassword } } = this.props;

    setPassword(value);
    this.onLogin();
  };

  /**
   * Do login.
   * */
  onLogin = async () => {
    var spinnerThing = document.querySelector('#spinnerThing');
    var spinnerBackground = document.querySelector('.spinner-background');
    spinnerThing.style.display = 'block';
    spinnerBackground.style.display = 'block';
    const {
      authenticationStore: {
        login,
        password,
        setError,
        username,
      }
    } = this.props;

    setError(null);

    if (!username) {
      setError(USERNAME_EMPTY);
      spinnerThing.style.display = 'none';
      spinnerBackground.style.display = 'none';
      return;
    }
    if (!isEmailValid(username)) {
      setError(INVALID_EMAIL_ADDRESS);
      spinnerThing.style.display = 'none';
      spinnerBackground.style.display = 'none';
      return;
    }
    if (!password) {
      setError(PASSWORD_EMPTY);
      spinnerThing.style.display = 'none';
      spinnerBackground.style.display = 'none';
      return;
    }

    await login();
    const authorizationToken = localStorage.getItem(LOCAL_STORE_AUTH_TOKEN);
    if (authorizationToken) {
      this.onGoToDefaultPage();
      setError(null);
      spinnerThing.style.display = 'none';
      spinnerBackground.style.display = 'none';
    }
  };

  /**
   * Navigates to default page.
   * */
  onGoToDefaultPage = () => {
    const { history } = this.props;

    history.push(PATH_DEFAULT);
  };

  /**
   * Navigates prentrom new account page.
   * */
  onSignUp = () => window.open(PRENTROM_CREATE_ACCOUT_URL, TARGET_BLANK);

  /**
   * Navigates prentrom forgot password page.
   * */
  onForgotPassword = () => window.open(PRENTROM_FORGOT_PASSWORD_URL, TARGET_BLANK);

  render() {
    /**
    * Navigates to default page if already logged in.
    * */
    const authorizationToken = localStorage.getItem(LOCAL_STORE_AUTH_TOKEN);
    if (authorizationToken) {
      this.onGoToDefaultPage();
    }
    const { authenticationStore: { error } } = this.props;

    return (
      <div className="authentication">
        <div className="logo">
          <img src="../../prc-saltillo-logo-stacked.png" alt="PRC Logo" />
          <div>Message Banking</div>
        </div>
        <div className="app-spinner">
          <div className="spinner-background hidden" />
          <p id="spinnerThing" className='hidden'><FontAwesomeIcon icon={faCircleNotch} size="3x" spin /></p>
        </div>
        <div className="form-inputs container">
          <TextInput
            inputClass="form-control-lg"
            onValueChange={this.onUsernameChange}
            placeholder="Username"
            type="text"
          />
          <TextInput
            inputClass="form-control-lg"
            onEnterKeyValueChange={this.onEnterKeyPasswordChange}
            onValueChange={this.onPasswordChange}
            placeholder="Password"
            type="password"
          />
          <Button
            buttonClass="btn btn-outline-primary btn-lg btn-block"
            onButtonClick={this.onLogin}
            title="Login"
          />
          <Button
            buttonClass="btn btn-auth-link btn-lg btn-block"
            onButtonClick={this.onSignUp}
            title="Create Account"
          />
          <Button
            buttonClass="btn btn-auth-link btn-lg btn-block"
            onButtonClick={this.onForgotPassword}
            title="Forgot Password"
          />
          <div className="error">{error}</div>
        </div>
      </div>
    );
  }
}

export default Authentication;



// WEBPACK FOOTER //
// ./src/messages/authentication/authentication.component.js